import { render, staticRenderFns } from "./PiChatDialog.vue?vue&type=template&id=313ea183&scoped=true"
import script from "./PiChatDialog.vue?vue&type=script&lang=js"
export * from "./PiChatDialog.vue?vue&type=script&lang=js"
import style0 from "./PiChatDialog.vue?vue&type=style&index=0&id=313ea183&prod&lang=scss"
import style1 from "./PiChatDialog.vue?vue&type=style&index=1&id=313ea183&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "313ea183",
  null
  
)

export default component.exports